module.exports = __webpack_public_path__ + "static/media/view3.bb0ff275.jpg";